var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"bar nobr",style:({ height: _vm._height })},'div',_vm.$attrs,false),_vm._l((_vm.items),function(item,ix){return _c('div',{key:ix,style:({
			background: item.color,
			width: _vm.getWidth(item.value) + '%',
			height: _vm._height,
			position: _vm.cumulative ? 'relative' : 'absolute',
		})})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }